export const INTERVAL_FOR_CHECK_XRPL_TRUSTLINE_TRANSACTION_STATUS = 5_000;
export const XRPL_PUBLIC_SERVER = 'wss://xrplcluster.com/';
